export default "__VITE_ASSET__Dsax_k32__"